export default "__VITE_ASSET__Ct03UXKi__"